import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, FileText, Facebook, Instagram, Linkedin } from 'lucide-react';
import { COMPANY_INFO } from '../data';

export default function Footer() {
  return (
    <footer className="border-t border-brand-grey bg-brand-black text-gray-600">
      {/* Bund-bar */}
      <div className="border-t border-brand-grey bg-brand-dark py-6 text-center text-xs text-gray-600">
        <div className="mx-auto max-w-7xl px-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p>© {new Date().getFullYear()} {COMPANY_INFO.name}. Alle rettigheder forbeholdes.</p>
          <p>CVR nr.: {COMPANY_INFO.cvr} | {COMPANY_INFO.address}</p>
        </div>
      </div>
    </footer>
  );
}
